import { AutogenModelFieldinfoNoLookupJoin, AutogenRowFieldinfoNoLookupJoin } from "./autogen/AutogenModelFieldinfoNoLookupJoin";

export class ModelFieldinfoNoLookupJoin extends AutogenModelFieldinfoNoLookupJoin<RowFieldinfoNoLookupJoin> {
	constructor() {
		super(RowFieldinfoNoLookupJoin);
	}
}

export class RowFieldinfoNoLookupJoin extends AutogenRowFieldinfoNoLookupJoin {
}